import script from "./produtoFilter.vue?vue&type=script&setup=true&lang=js"
export * from "./produtoFilter.vue?vue&type=script&setup=true&lang=js"

import "./produtoFilter.vue?vue&type=style&index=0&id=38a6c321&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-38a6c321"]])

export default __exports__